<template>
  <div class="talentList">
    <skeleton :skeletonType="'resumeList'" v-if="isLoading"></skeleton>
    <template v-if="( listOptions.total_count>0 && resumeListObj.searchList.length)">
      
      <div class='list bg_fff cursor_p pr transition_2' data-growing-title='简历卡片' data-growing-container v-for="(item, index) in resumeListObj.searchList" :key="item.resume._id + item.resume._score" @click="getDetail(item,index)">
        <div class="newtop-content bg_fa  f_14 color_9c">
          <!-- 顶部左侧 -->
          <div>
            <div class="flex">
              <div :class="['headImg pr', !userInfoState && index>=5 ? 'informationBlur' : '']" >
                <div class="pa img" :style="{backgroundImage:'url('+ (item.resume._source.resume.profile.avatar_url || headImgList.round[item.resume._source.resume.user_id%5]) +')',backgroundSize:'cover'}"></div>
                <div :style="{left:lastActiveAt(item.last_active_at) == '3日内活跃' ?  '-11px' : '-7px'}" class="online-text" v-if="lastActiveAt(item.last_active_at)"><div  class="circle"></div>{{lastActiveAt(item.last_active_at)}}</div>
              </div>
              <div class="user-info">
                <div class="flex">
                  <!-- 用户名 -->
                  <div class="new-username">
                    <div class="name color_40 f_18 font_w_b pr fl" :class="[ !userInfoState ? 'informationBlur4' : '']">{{item.resume._source.resume.basic_info.name}}</div>
                    <!-- <div class="onlineAt f_14 color_9c fl" v-if="lastActiveAt(item.last_active_at)" >{{lastActiveAt(item.last_active_at)}}</div> -->
                  </div>
                  <div class="leftItem color_40 f_14 beforeText" style="margin-bottom:10px">
                    <!-- 年纪 -->
                    <span class="display_ib" v-if="getAge(item.resume._source.resume.profile.birthday)" >{{getAge(item.resume._source.resume.profile.birthday)}}</span>
                    <!-- 性别 -->
                    <span class="display_ib" v-if="item.resume._source.resume.profile.gender" >{{item.resume._source.resume.profile.gender}}</span>
                    <!-- 工作年限/毕业时间 -->
                    <span class="display_ib" v-if="workingYears({profession_identity:item.profession_identity, years_of_work_experience:item.years_of_work_experience, selectedeXperience:searchListObj.selectedeXperience, graduate_at:item.resume._source.resume.basic_info.graduate_at})" >{{workingYears({profession_identity:item.profession_identity, years_of_work_experience:item.years_of_work_experience, selectedeXperience:searchListObj.selectedeXperience, graduate_at:item.resume._source.resume.basic_info.graduate_at})}}</span>
                    <!-- 最高学历 -->
                    <span class="display_ib" v-if="item.resume._source.resume.education_experiences && item.resume._source.resume.education_experiences[item.recent_edu_index]" >{{item.resume._source.resume.education_experiences[item.recent_edu_index].degree}}</span>
                  </div>
                </div>
                <div class="text beforeText fl color_40">
                  期望：
                  <span class="display_ib" v-if="(item.resume._source.resume.basic_info.predicted_location && item.resume._source.resume.basic_info.predicted_location.length) || (item.resume._source.resume.basic_info.expected_location && item.resume._source.resume.basic_info.expected_location.length)">{{item.resume._source.resume.basic_info.expected_location.length ? item.resume._source.resume.basic_info.expected_location.join('/') : item.resume._source.resume.basic_info.predicted_location.join('/')}}</span>
                  <span class="display_ib" v-if="item.resume._source.resume.profile.exp_job">{{item.resume._source.resume.profile.exp_job}}</span>
                  <span class="display_ib" v-else-if="item.resume._source.resume.basic_info.exp_job">{{item.resume._source.resume.basic_info.exp_job}}</span>
                  <span class="display_ib">{{expected_salary(item.resume._source.resume.profile.expected_salary) || expected_salary(item.resume._source.resume.basic_info.expected_salary)  || '面议'}}</span>
                </div>
                <!-- <div class="permissionState f_14 color_9c fr" v-if="!!item.hr_permission_state">{{item.hr_permission_state | hrPermissionState}}</div> -->
              </div>
            </div>
            <div class="highligt-body">
              <div v-for="(sitem,index) in item.heighlightTags" :key="index + 'c' + item.cv_account_token"  class="highlight">{{sitem}}</div>
              <div v-for="(sitem,index) in item.skillTags" :key="index + 'd' + item.cv_account_token"  class="skill-tags highlight">{{sitem}}</div>
            </div>
          </div>
          <!-- 顶部右侧 -->
          <div class="buttons_right">
            <el-tooltip v-if="(item.resume._source.contact_directly &&
              !(item.hr_permission_state==='rejected' || item.hr_permission_state==='passed') && 
              !item.resume.delivery_status ) || 
              (item.contact_directly &&
              !(item.hr_permission_state==='rejected' || item.hr_permission_state==='passed') && 
              !item.resume.delivery_status )
            " class="item" effect="dark" content="该人才可直接获取电话" placement="top-end" >
              <div :class="[(item.resume._source.contact_directly &&   
            !(item.hr_permission_state==='rejected' || item.hr_permission_state==='passed') && 
            !item.delivery_status)|| 
              (item.contact_directly &&
              !(item.hr_permission_state==='rejected' || item.hr_permission_state==='passed') && 
              !item.resume.delivery_status )
             ? 'buttons' : 'buttons bg_60 color_9c disabled']" @click.stop="getPhone({item, index})">
                <span class="iconfont iconGroup311" ></span> 
                <p>查看电话</p>
              </div>
            </el-tooltip>
          <div class="standard-btn-content">
              <div v-if="item.contact_directly && !item.hr_permission_state && !item.delivery_status" class="standard-btn-left" @click.stop="resumeApply(item.hr_permission_state, JSON.parse(JSON.stringify(item)), index)">
                <!-- <span class="iconfont iconGroup311" v-if="item.contact_directly && !item.hr_permission_state && !item.delivery_status"></span> -->
                {{!item.hr_permission_state && !item.delivery_status ? '联系Ta' : '继续沟通'}}
              </div>
            <div v-else class="standard-btn-left" @click.stop="resumeApply(item.hr_permission_state, JSON.parse(JSON.stringify(item)), index)">
              <!-- <span class="iconfont iconGroup311" v-if="item.contact_directly && !item.hr_permission_state && !item.delivery_status"></span> -->
              {{!item.hr_permission_state && !item.delivery_status ? '联系Ta' : '继续沟通'}}
            </div>
            <div class="standard-btn-right" @click.stop="item.is_favorite ? changeCancelState(item) : resumeCollect(item,index)">
              <span class="iconfont pr" :class="[item.is_favorite ? 'iconfavoritesactive star color_ffc':'iconfavorites star color_40']"></span>
              {{item.is_favorite?'移除储备':'储备'}}
            </div>
          </div> 
          </div>
        </div>

        <div class="userInfo flex new-content">
         

          <!-- 中间内容区域 -->
          <div class="centerContent flex1 clearfix" :class="[searchListObj.keyword_seg.length && highlightLength(item, item.resume._source.resume, item.keyword_hit).l ? '' : 'hasHighlightLength']">     
            <div class="fl flex" style="overflow: inherit; width: 100%;">
              <!-- 工作经历 -->
              <div class="work-list pr flex1">
                <!-- 左侧分割线 -->
                <div class="divid pa text_center color_fff">
                  <div class="start iconfont iconGroup32 pa"></div>
                </div>

                <div class="item" v-if="!(filterWork(item.resume._source.resume.work_experiences).length + filterWork(item.resume._source.resume.internship_experiences).length + item.resume._source.resume.education_experiences.length)">
                  <div class="name f_14 color_40 beforeText">这位候选人还没有任何经历，快去看看其他候选人吧～</div>
                </div>
                <div class="item" v-else-if="!(filterWork(item.resume._source.resume.work_experiences).length + filterWork(item.resume._source.resume.internship_experiences).length)">
                  <div class="text f_12 color_9c beforeText mr48"> - </div>   
                  <div class="name f_14 color_40 beforeText">暂无工作经历</div>
                </div>
               <template >
                  <!-- 有工作经历 -->
                  <template v-if="filterWork(item.resume._source.resume.work_experiences).length">
                    <template v-for="(item,index) in filterWork(item.resume._source.resume.work_experiences, item.keyword_hit)" >
                      <div class="item" :key="'work_experiences_'+String(index)" v-if="index<2">
                        <div class="text f_12 color_9c beforeText mr48">
                          <span class="display_ib time" v-if="item.start_at||item.end_at || item.present">
                            <i v-if="item.start_at">{{splitTime(item.start_at)}}</i>
                            <i v-if="item.end_at || item.present">{{splitTime(item.end_at || item.present)}}</i>
                          </span>
                          <span class="display_ib">就职</span>
                          <span class="display_ib" v-if="getWorkTimeLength({start_at: item.start_at, end_at: item.end_at, present:item.present})">{{getWorkTimeLength({start_at: item.start_at, end_at: item.end_at, present:item.present})}}</span>
                        </div>
                        <div class="name f_14 color_40 beforeText ellipsis">
                          <span class="ellipsis" v-if="item.company_name" v-html="item.company_name"></span>
                          <span class="ellipsis" v-if="item.job_title" v-html="item.job_title"></span>
                        </div>
                      </div>
                    </template>
                  </template>

                  <!-- 实习经历 -->
                  <template v-if="filterWork(item.resume._source.resume.work_experiences).length<2 && filterWork(item.resume._source.resume.internship_experiences).length">
                    <template v-for="(sitem,sindex) in filterWork(item.resume._source.resume.internship_experiences, item.keyword_hit)" >
                      <div class="item" :key="'internship_experiences_'+String(sindex)" v-if="sindex < (filterWork(item.resume._source.resume.work_experiences).length ? 1 : 2)">
                        <div class="text f_12 color_9c beforeText mr48">
                          <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                            <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                            <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                          </span>
                          <span class="display_ib">实习</span>
                          <span class="display_ib" v-if="getWorkTimeLength({start_at: sitem.start_at, end_at: sitem.end_at, present:sitem.present})">{{getWorkTimeLength({start_at: sitem.start_at, end_at: sitem.end_at, present:sitem.present})}}</span>
                        </div>
                        <div class="name f_14 color_40 beforeText ellipsis">
                          <span class="ellipsis" v-if="sitem.company_name" v-html="sitem.company_name"></span>
                          <span class="ellipsis" v-if="sitem.job_title" v-html="sitem.job_title"></span>
                        </div>
                      </div>
                    </template>
                  </template>
                  
                  <!-- 项目经历 -->
                  <template v-if="(filterWork(item.resume._source.resume.work_experiences).length + filterWork(item.resume._source.resume.internship_experiences).length)<2 && filterCustomSections(item.resume._source.resume.project_experiences).length">
                    <template v-for="(sitem, sindex) in filterCustomSections(item.resume._source.resume.project_experiences)" >
                      <div class="item" :key="'project_experiences'+sindex" v-if="sindex<1">
                        <div class="text f_12 color_9c beforeText mr48">
                          <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                            <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                            <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                          </span>
                          <span class="display_ib">项目</span>
                        </div>
                        <div class="name f_14 color_40 beforeText ellipsis">
                          <span class="ellipsis" v-if="sitem.name">{{sitem.name}}</span>
                          <span class="ellipsis" v-if="sitem.title">{{sitem.title}}</span>
                        </div>
                      </div>
                    </template>
                  </template>

                  <!-- 社团经历 -->
                  <template v-if="(filterWork(item.resume._source.resume.work_experiences).length + filterWork(item.resume._source.resume.internship_experiences).length)<2 && !filterCustomSections(item.resume._source.resume.project_experiences).length && filterInfoSections(item.resume._source.resume.orgs).length">
                    <template v-for="(sitem, sindex) in filterInfoSections(item.resume._source.resume.orgs)" >
                      <div class="item" :key="'orgs'+sindex" v-if="sindex<1">
                        <div class="text f_12 color_9c beforeText mr48">
                          <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                            <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                            <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                          </span>
                          <span class="display_ib">社团</span>
                        </div>
                        <div class="name f_14 color_40 beforeText">
                          <span class="ellipsis" v-if="sitem.name">{{sitem.name}}</span>
                          <span class="ellipsis" v-if="sitem.title">{{sitem.title}}</span>
                        </div>
                      </div>
                    </template>
                  </template>

                  <!-- 教育经历 -->
                  <template v-if="item.resume._source.resume.education_experiences.length > 0" >
                    <template v-for="(sitem,sindex) in item.resume._source.resume.education_experiences">
                      <div class="item" :key="sindex" v-if="sindex < 2">
                        <div v-if="sindex == 0" class="divid-end text_center color_fff iconfont iconGroup12 pa"></div>
                        <div class="text f_12 color_9c mr48">
                          <span class="display_ib time" v-if="sitem.start_at">{{splitTime(sitem.start_at.split(' ')[0])}}</span>-
                          <span v-if="sitem.end_at">{{splitTime(sitem.end_at.split(' ')[0])}}</span>
                        </div>
                        <div :class="[{splitnone: schoolTag(sitem.school_tags)},'name f_14 color_40 beforeText ellipsis']">
                          <span class="ellipsis" v-if="sitem.school_name">{{sitem.school_name}}</span>
                          <span class="ellipsis" v-if="sitem.major">{{sitem.major}}</span> 
                          <span v-if="sitem.degree">{{sitem.degree}}</span>
                          <span v-if="sitem.edu_type==='非全日制'" >非全日制</span>
                          <div class="schoolTag f_12 color_blue fl" v-if="schoolTag(sitem.school_tags)">{{schoolTag(sitem.school_tags)}}</div>
                        </div>
                      </div>
                    </template>
            
                  </template>
                </template>
              </div>
            </div>

          </div>

          <div v-if="!!item.hr_permission_state" :class="['invited-status','position_b_86',{'resove-status': item.hr_permission_state !== 'rejected' }]">{{ item.hr_permission_state === 'rejected' ? '邀约被拒' : (item.hr_permission_state === 'passed')  ? '已通过' : '待通过' }}</div>
        </div>
        <Group :currentResume="currentResume" @close="()=>{showGroup=!showGroup}" v-if="showGroup && currentResume && (isSearchData ? (item.resume._source.id == currentResume.id) : (item.resume.id == currentResume.resume.id))"  :top="'88px'" :right="'32px'"></Group>
        <CancelCollection :currentResume="currentResume.resume" @close="()=>{showCancelCollection=!showCancelCollection}" @setGroup="setGroup" @cancel="resumeCollect(item,index)" v-if="showCancelCollection && currentResume && (isSearchData ? (item.resume._source.id == currentResume.id) : (item.resume.id == currentResume.resume.id))"  :top="'88px'" :right="isSearchData ? '32px' : '75px'" />
      </div>


      <!-- <el-pagination background layout="prev, pager, next" :total="listOptions.total_count" :page-size="15" :currentPage="Number(pageNo)" @current-change='pageChange' class="searchPagination text_center" v-if="listOptions.total_count>15"></el-pagination> -->
    </template>
    <!-- 加载到底部提示 -->
    <div class="listMoreEndTips text_center pr f_14 color_cf" v-if="!isLoading && Math.ceil(listOptions.total_count/15)===listOptions.page">
      <p class="pr">已经到最底部了</p>
    </div>

    <template v-else-if="!isLoading && (!listOptions.total_count || !resumeListObj.searchList.length)">
      <div class="notfound bg_fff text_center">
        <img src="https://files.wondercv.com/b-pc/no-search-data.png" alt="">
        <p>没有找到符合条件的人才～</p>
      </div>
    </template>

    <!-- 申请简历弹窗 -->
    <resume-apply v-if="showResumeApplyState"/>
    <!-- 无简历提示 -->
    <notfind-resume v-if="notfindResumeState" @setNotfindResumeState="setNotfindResumeState" />
    <!-- 绑定手机号弹窗 -->
    <bind-phone v-if="showBindPhone" @bindPhoneSuccess="bindPhoneSuccess" @closeBindPhone="closeBindPhone" />
    <!-- 购买查看电话次数弹窗 -->
<!--    <job-pay-dialog -->
<!--      v-if="showBuyPhoneState" -->
<!--      payType="bPhone" -->
<!--      :orderPriceText="1050" -->
<!--      type="phone" -->
<!--      title="查看电话" -->
<!--      subtitle="无需等待候选人同意邀约，直接查看联系方式，购买后无使用限制，用完即止"-->
<!--      @paidFunc="paidSuccFunc"-->
<!--      @closeFunc="closeBuyPhone"/>-->
  </div>
</template>

<script>
//混入优化
import {mixinsUtils} from '@/mixins/search/utils';
// 所有接口
import actions from '@/actions/index'

import { mapState, mapMutations, mapActions } from 'vuex'

import {checkUserState, get_tUser, replaceAll } from '@/utils/utils';

import { filterInfoSections, filterCustomSections, getAge, applied_at, getDegreeName, getWorkTimeLength ,schoolTag} from '@/utils/resumeList';
//申请简历
import ResumeApply from '@/components/block/ResumeApply'
// 无简历提示
import NotfindResume from '@/components/notfind-resume/index'
//绑定手机号
import BindPhone from '@/components/bindPhone'
// import JobPayDialog from '@/components/block/JobPayDialog'
import skeleton from '@/components/skeletonDiagram/index.vue'
import Group from '@/components/collection/group.vue'
import CancelCollection from '@/components/collection/CancelCollection.vue'

export default {
  name: 'searchTalentPage',
  mixins:[mixinsUtils],
  props:{
    // 是否显示推荐 tag
    recommendTagVisible: {
      type: Boolean,
      default: false
    },
    isLoading:{},
    classType:{
      default:1
    },
    selectedeXperience:{}, //选中的经验
    isFirstQuery:{
      default:true
    },
    jobTypeIsOnline:{
      type:Boolean,
      default:false
    },
    isSearchData: {
      type: Boolean,
      default:false
    }
  },
  data(){
    return {
      VUE_APP_ENV_TYPE: process.env.VUE_APP_ENV_TYPE,
      notfindResumeState: false, //是否显示无在线简历提示
      userJWT:{},
      showBindPhone: false, //是否显示绑定手机号弹窗
      bindData:{}, //账户绑定数据
      showGroup: false,  // 展示分组
      showCancelCollection: false,  // 展示取消收藏的弹窗
      currentResume: '' // 当前点击的简历卡片
    }
  },
  computed:{
    ...mapState('block',['userInfoState','userinfoTipsState', 'favoritesId', 'showResumeApplyState','showBuyPhoneState','getPhoneNumber']),
    ...mapState('im',[ 'hr_account_token']),
    ...mapState('resumeDetails',['resumeListObj', 'myPosition', 'listOptions', 'searchListObj'])
  },
  components:{
    ResumeApply,
    NotfindResume,
    BindPhone,
    // JobPayDialog,
    skeleton,
    Group,
    CancelCollection
  },
  created() {
    this.userJWT = get_tUser();
    // 获取用户绑定信息
    this.getUsersBind();
  },
  methods:{
    ...mapMutations('block',['toggleUserInfoState', 'toggleUserinfoTips', 'IsFavorites', 'updateBlockStateFun','toggleTipsType','updatePhoneNumberStateFun','updatePhoneNumberToken','updatePhoneNumber']),
    ...mapMutations('resumeDetails',['updateListOptions','updateResumeListObj','updateDownloadResumeInfo']),
    ...mapActions('resumeDetails',['getMyPosition']),
    ...mapMutations('userBindInfo', ['setBindInfo']),
    changeCancelState(item) {
      console.log()
      this.showCancelCollection = true
      this.currentResume = this.isSearchData ? item.resume._source : item
      console.log(this.currentResume.id,"=======================>item")
    },
    // 移除储备时选择分组
    setGroup() {
      // this.currentResume = item
      this.showGroup = true
    },
    pageChange(e){
      this.$emit('pageChange',e)
    },
    //进入详情页
    getDetail(item,index){
      // // 将列表简历的基本信息存入vuex
      // this.updateSearchResumeBasic(item)
      this.updateDownloadResumeInfo(item)
      //列表数据同不到vuex
      this.updateListOptions({
        ... this.listOptions,
        resumeIndex: index,
      });
      let token = item.resume._source.token;
      this.$emit('getDetail',{token,keyword_hit:item.keyword_hit, item})
    },

    //收藏/取消收藏
    async resumeCollect(item, index, favoriteToken){
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          // this.$router.replace({name:'talentSearchIndex'});
          // return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });
      let token = '';
      let is_favorite = false;
      if(index >-1){
        if(favoriteToken){
          item = this.resumeListObj.searchList[index];
        }
        token = item.resume._source.token;
        is_favorite = item.is_favorite;
      }else{
        token = favoriteToken;
        is_favorite = false;
      }

      //引导用户完善信息弹层
      if(!this.userInfoState){
        let user = get_tUser();
        if(user.h_t){
          //更新是否完善信息(状态库)
          let userInfo = await actions.hr_accounts.getUserinfo();
          this.toggleUserInfoState(userInfo)
        }
        if(!this.userInfoState){
          //提示
          this.toggleUserinfoTips(true);
          //通知状态库
          this.IsFavorites(token)
          return false;
        }
      }
      //通知状态库
      this.IsFavorites('');
      
      let data = {
        token,
        type: is_favorite ? 'dislike' : 'like'
      }

      // b向c发送通知
      if(!is_favorite && item.cv_account_token){
        actions.im.sendNotifications({
          type: 'collect',
          cv_account_token: item.cv_account_token,
          app_push: true,
          wechat_message: true
        })
      }
      // 储备
      let flag = true
      if(!is_favorite){
        let res = await actions.favorites.favorites_add_group({token})
        if(res.code == 1000) {
          this.$message.success('已储备至默认分组')
          this.currentResume = this.isSearchData ? item.resume._source : item
          this.showGroup = true
        } else {
          this.$message.error(res.message)
          flag = false
        }
      } else {
        let ress = await actions.favorites.favorites_chancle_group({token})
          if(ress.code == 1000) {
            this.$message.success('移除成功')     
          } else {
            this.$message.error(ress.message)
            flag = false
          }  
      }
      if(flag && index >-1) {
        item.is_favorite = item.is_favorite ? false : true;
        this.resumeListObj.searchList[index] = item;
        this.updateResumeListObj({key:'searchList', value: this.resumeListObj.searchList});
      }
    },
    //判断是否满足为匹配上的判断
    highlightLength(listItem, resume, keywordsBat, index){
      // 匹配词转小写
      keywordsBat = keywordsBat.map(item=>item.toLowerCase());
      // 初始化对象
      let keywordsBatHighlightLength = {};
      keywordsBat.forEach(key=>{
        keywordsBatHighlightLength[key] = 0
      })

      //拿到过滤之后的公司列表
      if(resume.work_experiences){
        let workList = this.filterWork(resume.work_experiences, keywordsBat);
        if(workList.length){
          workList.forEach((item,index)=>{
            let company_name = item.company_name.split(`<span class="es-highlighter">`).join('').split('</span>').join('').toLowerCase();
            let job_title = item.job_title.split(`<span class="es-highlighter">`).join('').split('</span>').join('').toLowerCase();
            
            if(index<2){
              keywordsBat.forEach(key=>{
                if(company_name.includes(key) || job_title.includes(key)){
                  keywordsBatHighlightLength[key] = keywordsBatHighlightLength[key]+1
                }
              })
            }
          })
        }
      }
      let schoolHtml = this.schoolHtml(listItem);
      schoolHtml.forEach((item,index)=>{
        schoolHtml[index] = item.replace(/\<i class="es-highlighter">/g, '' )
        schoolHtml[index] = item.replace(/\<\/i>/g, '' );
      })
      keywordsBat.forEach(key=>{
        schoolHtml.forEach((item,index)=>{
          if(item.includes(key) && index<2){
            keywordsBatHighlightLength[key] = keywordsBatHighlightLength[key]+1
          }
        })
      })

      let l = 0;
      for (let key in keywordsBatHighlightLength) {  
        if(keywordsBatHighlightLength[key]<1){
          l+=1
        }
      } 
      return {
        labels:keywordsBatHighlightLength,
        l
      }
    },
    //过滤空公司信息
    filterWork(work_experiences, keyword_hit=[]){
      // console.log(work_experiences)
      if(!work_experiences || !work_experiences.length){
        return []
      }
      let workList = []
      work_experiences = JSON.parse(JSON.stringify(work_experiences));
      work_experiences.forEach(item=>{
        let company_name = item.company_name || ''
        let job_title = item.job_title || '';
        // let reg = '';
        // let str = '';
        // for (let i = 0; i < keyword_hit.length; i++) {
        //   if (str) str += '|'
        //   str += keyword_hit[i];
        // }
        // reg = RegExp(`.*?(${str}).*?`, 'gim');
        // item.company_name = company_name.replace(reg, `<span class="es-highlighter">$1</span>`)
        // item.job_title = job_title.replace(reg, `<span class="es-highlighter">$1</span>`)
        keyword_hit.forEach(sitem=>{
          if(sitem.length>1){
            let sitemText = sitem.replace(/\+/g,'\\+').replace(/\|/g,'\\|').replace(/\^/g,'\\^').replace(/\$/g,'\\$').replace(/\*/g,'\\*').replace(/\./g,'\\.');
            company_name && (company_name = company_name.replace(new RegExp(sitemText,'g'),`<span class="es-highlighter">${sitem}</span>`))
            job_title && (job_title =  job_title.replace(new RegExp(sitemText,'g'),`<span class="es-highlighter">${sitem}</span>`))
          }
        })
        
        if(company_name || job_title){
          workList.push(item)
        }
      })
      return workList;
    },

    // 发送邀约
    async resumeApply(state, item, index){
      //如果投递字段为true 将hr状态调整为passed  状态state调整为true
      if(item.delivery_status){
        item.hr_permission_state = 'passed'
        state = true
      }
      // return
      // 需要检查用户在线简历状态 && 未邀约
      if(item.cv_invisibile && !item.hr_permission_state){
        this.setNotfindResumeState(true);
        return false
      }

      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1:()=>{
          // this.$router.replace({name:'talentSearchIndex'});
          // return false;
        },
        callback2:()=>{
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });

      //引导用户完善信息弹层
      if(!this.userInfoState){
        let user = get_tUser();
        if(user.h_t){
          //更新是否完善信息(状态库)
          let userInfo = await actions.hr_accounts.getUserinfo();
          this.toggleUserInfoState(userInfo)
        }
        if(!this.userInfoState){
          //提示
          this.toggleUserinfoTips(true)
          return false;
        }
      }
      // 检查是否已经邀约过
      if(state){
        let { cv_account_token } = item;
        if(!cv_account_token){
          this.$message({
            message: '对方身份状态异常，无法创建聊天',
            type: 'success'
          });
          return
        }
        let data = {
          b_token: this.hr_account_token,
          c_token: cv_account_token,
          identity: item.delivery_status ? 'c' : 'b'
        }
        actions.im.post_relationships(data).then(async res=>{
          if(res.code === 1000){
            // 恢复隐藏好友状态
            try {
              await actions.im.putRelationshipsHide({
                b_token: this.hr_account_token, //用户token,
                c_token: cv_account_token, //被曝光的关系id
                b_hide: false, //是否隐藏联系人
              })
            } catch (error) { }
            setTimeout(() => {
              window.open(`${window.location.origin}/talent/chat?chat_id=${cv_account_token}`)
              // this.$router.push({path:'/talent/chat', query:{ chat_id: cv_account_token}})
            }, 300);
          }
        })
        return
      }
      // if(state === 'applied'){
      //   this.$message({
      //     message: '人才已收到邀约！继续联系更多人才获得回复率更高哦~',
      //     type: 'warning'
      //   });
      //   return false;
      // }
      // if(state === 'passed'){
      //   this.$message({
      //     message: '已通过',
      //     type: 'warning'
      //   });
      //   return false;
      // }
      // if(item){
      //   this.updateResumeDetail(item)
      // }
      if(!this.showResumeApplyState){
        //更新职位列表
        try {
          await this.getMyPosition()
        } catch (error) {}
        if(!this.myPosition.list.length){
          //提示
          this.toggleUserinfoTips(true)
          //更新信息弹层 提示文案类型
          this.toggleTipsType(2)
          return false;
        }

        // 检查是否绑定手机号
        if(!this.bindData.phone_is_bound){
          this.showBindPhone = true
          return
        }
        
        this.updateListOptions({
          ...this.listOptions,
          resumeIndex: index
        })
        //切换展示简历邀约样式
        this.updateBlockStateFun({type: 'showResumeApplyState', value: true})

        return false;
      }
      

    },
    // 更改无简历弹窗提示
    setNotfindResumeState(state){
      this.notfindResumeState = state;
    },
    //获取用户绑定信息
    getUsersBind(){
      actions.auth.getUserBind(this.userJWT.t).then(res=>{
        if(res.code === 1000){
          this.bindData = res.data;
          this.setBindInfo(this.bindData)
        }
      })
    },
    //手机号绑定成功回调
    bindPhoneSuccess(){
      //重新获取用户绑定信息
      this.getUsersBind();
      this.showBindPhone = false;
    },
    // 关闭绑定手机号
    closeBindPhone(){
      this.showBindPhone = false;
    },
    //获取查看手机号次数
    async getPhone({item, index}){
      if(!this.myPosition.list.length){
        //提示
        this.toggleUserinfoTips(true)
        //更新信息弹层 提示文案类型
        this.toggleTipsType(4)
        return false;
      }
      //列表数据同步到vuex
      this.updateListOptions({
        ... this.listOptions,
        resumeIndex: index,
      });
      if(!(item.getPhoneState  || ( item.hr_permission_state==='rejected' || item.hr_permission_state==='passed'))){
        let res = await actions.job_deliveries.get_phone_times({});
        if(res.code === 1000){
          // this.updatePhoneNumber(res.data.check_contact_count )
          this.updatePhoneNumber(res.data.count)
        }else{
          this.updatePhoneNumber(0)
        }
        if(this.getPhoneNumber < 1){
          let params = {
            plan: 'view_phone_30',
          }
          let res = await actions.recruit_infos.create_order(params)
          if(res.code === 1000){
            this.updatePhoneNumberToken(res.data.order_token)
            this.updatePhoneNumberStateFun(true)
          }
        }else{
          this.toggleUserinfoTips(true);
          //更新信息弹层 提示文案类型
          this.toggleTipsType(3)
          // 更新搜索主页参数
          this.updateSearchIndexObj({
            listIndex:index,
            itemIndex: index,
          });
          this.updateResumeDetailToken(item.resume._source.token)
          //更新页面数据
          let profile_data = {
            resume:{
              info:item.resume._source.resume.profile,
              token:item.resume._source.token
            }
          }
          this.updateResumeDetail(profile_data);
        }
      }
    },
    // closeBuyPhone(){
    //   this.updatePhoneNumberToken('')
    //   this.updatePhoneNumberStateFun(false)
    // },
    // paidSuccFunc(){
    //   this.updatePhoneNumberToken('')
    //   this.updatePhoneNumberStateFun(false)
    // },
    filterInfoSections, //过滤模块
    filterCustomSections, //获取自定义模块数据
    getAge, //获取年龄
    applied_at, //时间
    getDegreeName, //获取专业名称
    getWorkTimeLength,
    schoolTag
  }
}
</script>

<style lang="scss" scoped>

@import './Index.scss';
/deep/ .beforeText > span:before{
  color: #CFCFCF;
  bottom: 1px;
}
</style>